import React from "react";
import { Checkbox, Chip, ListItemText, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Select from "@mui/material/Select";
import { Box } from "@mui/system";
import {
  StyledHelperText,
  StyledInputLabel,
  StyledSelect,
} from "./StyledSelect";

const Multiselect = React.forwardRef(({
  label,
  options,
  value,
  onChange,
  placeholder,
  error,
  helperText,
  onBlur,
  disabled,
  required,
  id,
  objectOptions = false,
}, ref) => {
  const renderOptions = () => {
    if (objectOptions) {
      return options?.map((val, idx) => (
        <MenuItem key={idx} value={val}>
          <ListItemText primary={val.name} />
          <Checkbox 
            checked={value.some((item) => item.id === val.id)}
            onChange={(event) => {
              const newValue = event.target.checked
                ? [...value, val]
                : value.filter((item) => item.id !== val.id);
              onChange({ target: { value: newValue } });
            }}
          />
        </MenuItem>
      ));
    } else if (options && !objectOptions) {
      return options?.map((val, idx) => (
        <MenuItem key={idx} value={val}>
          <ListItemText primary={val} />
          <Checkbox checked={value.indexOf(val) > -1} />
        </MenuItem>
      ));
    }
  };
  return (
    <StyledSelect>
      <StyledInputLabel>
        {label}
        {required && <span className='required'> * </span>}
      </StyledInputLabel>
      <Select
        id={id}
        disabled={disabled}
        displayEmpty
        fullWidth
        multiple
        labelId='multi-selectlabel'
        value={value}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        error={error}
        onBlur={onBlur}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200,
              overflowY: "auto",
            },
          },
        }}
        renderValue={(selected) => {
          if (selected?.length) {
            const numTags = selected?.length;
            const limitTags = 1;
            return (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                {selected.slice(0, limitTags).map((option, index) => (
                  <Chip
                    key={index}
                    label={objectOptions ? option.name : option}
                    sx={{
                      maxWidth: "100px",
                      borderRadius: "4px",
                      height: "26px",
                      overflow: "hidden",
                    }}
                  />
                ))}
                {numTags > limitTags && ` +${numTags - limitTags}`}
              </Box>
            );
          }
          return <span className='placeholder'>{placeholder}</span>;
        }}
      >
        {renderOptions()}
      </Select>
      <StyledHelperText>{helperText}</StyledHelperText>
    </StyledSelect>
  );
});

export default Multiselect;
